import { render, staticRenderFns } from "./ConsultantContracts.vue?vue&type=template&id=82f623da&"
import script from "./ConsultantContracts.vue?vue&type=script&lang=ts&"
export * from "./ConsultantContracts.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultantContracts.vue?vue&type=style&index=0&id=82f623da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports